import { Outlet } from "react-router-dom";
import Fakebar from "../routes/navholder";

const Layout = () => {
  return (
    <>
      <Fakebar />
      <main className="App">
        <Outlet />
      </main>
    </>
  );
};

export default Layout
